//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'dayjs'; // Drop in replacement for moment
import relativeTime from 'dayjs/plugin/relativeTime';

moment.extend(relativeTime);

export default {
  name: 'DealBanner',
  props: {
    deal: {
      type: Object,
      required: true,
    },
    isBlackFridayLastCall: {
      type: Boolean,
      required: true,
    },
    isLastCall: {
      type: Boolean,
      required: true,
    },
    isLimitedTimeSale: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    const ret = {
      hasBanner: false,
      bannerText: '',
      isSoldOut: false,
      isComingSoon: false,
      isEnding: false,
    };

    if (this.deal.buy_button && this.deal.buy_button.is_coming_soon === true) {
      ret.hasBanner = true;
      ret.isComingSoon = true;
      ret.bannerText = 'Coming soon!';
    } else if (this.deal.browse_deal_status === 'expired') {
      ret.hasBanner = true;
      ret.isSoldOut = true;
      ret.bannerText = 'Sold out';
    } else if (this.isLimitedTimeSale) {
      ret.hasBanner = true;
      // jl: 72 hour sale applies to black friday's last call
      ret.bannerText = this.isLastCall ? '96 hour sale only' : '72 hour sale only';
    } else if (this.deal.shows_codes_remaining && this.deal.codes_remaining > 0) {
      ret.hasBanner = true;
      ret.bannerText = `Only ${this.deal.codes_remaining} remaining`;
    } else if (this.canShowTimer()) {
      ret.hasBanner = true;
      ret.bannerText = `Offer ends ${moment(this.deal.dates.end_date).fromNow()}`;
      ret.isEnding = true;
    }

    return ret;
  },
  mounted() {
    this.intervalId = null;
    if (this.isEnding && this.canShowTimer()) {
      this.generateTimerInterval();
    }
  },
  beforeUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },
  methods: {
    canShowTimer() {
      return this.deal.dates
          && this.deal.dates.end_date
          && this.deal.has_started
          && this.deal.active_timer
          && this.dealIsLive();
    },
    generateTimerInterval() {
      this.intervalId = setInterval(() => {
        if (this.dealIsLive()) {
          this.hasBanner = true;
          this.isEnding = true;
          this.bannerText = `Offer ends ${moment(this.deal.dates.end_date).fromNow()}`;
        } else {
          this.hasBanner = false;
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }, 30000);
    },
    dealIsLive() {
      return this.deal.browse_deal_status === 'current';
    },
  },
};
